import axios from "axios";

export const updateProfessionalTournament = async (data, token) => {
  try {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("yt_link", data.yt_link);
    formData.append("category", data.type);
    if (data?.video && Array.isArray(data.video)) {
      data.video.forEach((video) => {
        if (video instanceof File) {
          formData.append("video", video);
        }
      });
    }
    if (data?.image && data?.image instanceof File) {
      formData.append("image", data.image);
    }

    formData.append("id", data.id);
    data.deletedVideos.map((id) => {
      formData.append("deletedVideos[]", id);
    });
    if (data.goalVideos && Array.isArray(data.goalVideos)) {
      data.goalVideos.forEach((goal) => {
        if (goal.goal_image instanceof File) {
          formData.append("goalImages", goal.goal_image);
        }
      });
    }

    if (data?.YTVideo && data?.YTVideo instanceof File) {
      formData.append("ytVideo", data.YTVideo);
    }

    // data.edited_videos.map((v) => {
    formData.append("edited_video", JSON.stringify(data.edited_videos));
    // });

    // data.video_meta.map((v)=>{
    formData.append("video_meta", JSON.stringify(data.video_meta));
    // })

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/editProfessionalTournament`,
      formData,
      {
        headers: {
          // "Content-Type" : "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message);
    }
    if (error.request) {
    }
    throw new Error(error.message);
  }
};
